import React from 'react';
import App from './App';

class IcdApp extends React.Component {
  render() {
    return (
      <App {...this.props} />
    );
  }
}

export default IcdApp; 
